import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { activeAutom, errorHandlingActiveAutom } from "../../../../recoil-store/recoil-state";
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';

function Group({ action, variables, setOpenVariable, setGroupLabel, actions, isEhFlow }) {
	const { t } = useTranslation();
	// It is not newly created TR & EN  because it has the same labels.
	const label = "CONTENT.CONFIGURATION-FORM.GROUPING.";
	const [automDetail, setAutomDetail] = useRecoilState(isEhFlow ? errorHandlingActiveAutom : activeAutom);
	const [outLabel, setOutLabel] = useState({ isOk: false, value: "" });

	const updateLabel = (id, items) => {
		let isDifferentLabel
		const innerUpdateLabel = (id, items) => {
			items.forEach(item => {
				if (item.id === id) {
					item.fields = action.fields;
					if (item.label !== action.fields.label.value && (item.label !== undefined || action.fields.label.value)) {
						item.label = action.fields.label.value;
						isDifferentLabel = true
					}
				} else if (item.children) {
					innerUpdateLabel(id, item.children);
				}
			});
		}
		innerUpdateLabel(id, items)
		return isDifferentLabel
	};

	useEffect(() => {
		if (action.fields?.label) {
			setOutLabel({ isOk: true, value: action.fields.label.value })
		}
	}, [actions])

	const handleBlur = () => {
		let fields = action.fields;
		let items = JSON.parse(JSON.stringify(automDetail.items));
		action.fields = JSON.parse(JSON.stringify(fields));
		updateLabel(action.id, items);
		setAutomDetail({ ...automDetail, items: JSON.parse(JSON.stringify(items)) });
	};
	return (
		<div>
			<div className="form-element">
				{t(label + "LABEL")}
				<TextInput
					action={action}
					inputName="label"
					variables={variables}
					setOpenVariable={setOpenVariable}
					isRequired={false}
					onBlur={handleBlur}
					outNewValue={outLabel}
					limit={40}
				/>
			</div>
		</div>
	);
}
export default Group;